import _ from 'lodash'
import React, { useEffect, useMemo } from 'react'

import AddDoctorDialog, { AddDoctorDialogProps } from '@/components/group/AddDoctorDialog'
import { DoctorData } from '@/components/group/AddDoctorTable'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import {
  getMedecins,
  selectMedecinListRequestTracker,
  selectMedecins,
  selectMedecinSearchParams,
  selectMedecinSearchResults,
} from '@/redux/reducers/medecin.reducer'

type AddDoctorDialogContainerProps = Pick<AddDoctorDialogProps, 'isAdding' | 'onAddDoctor' | 'onClose' | 'open'> & {}

export default function AddDoctorDialogContainer(props: AddDoctorDialogContainerProps) {
  const dispatch = useAppDispatch()

  const doctors = useAppSelector(selectMedecins)
  const doctorSearchParams = useAppSelector(selectMedecinSearchParams)
  const doctorSearchResult = useAppSelector(selectMedecinSearchResults)
  const doctorListRequestTracker = useAppSelector(selectMedecinListRequestTracker)

  const doctorsData: DoctorData[] = useMemo(
    () =>
      _.map(doctors, (medecin) => ({
        name: medecin.name,
        surname: medecin.surname,
        gender: medecin.gender,
        city: medecin.city,
        cps: medecin.cps,
        email: medecin.email,
      })),
    [doctors]
  )

  useEffect(() => {
    const options = {
      limit: 5,
      skip: 0,
      orderBy: 'name',
    }
    dispatch(getMedecins({ surname: '1000' }, options))
  }, [dispatch])

  const handleItemsPerPageChange = (newItemsPerPage: number) => {
    dispatch(getMedecins(doctorSearchParams.query, { limit: newItemsPerPage }))
  }

  const handlePageChange = (newPage: number, itemsPerPage: number) => {
    dispatch(getMedecins(doctorSearchParams.query, { limit: itemsPerPage, skip: (newPage - 1) * itemsPerPage }))
  }

  const handleSearchDoctor = (textSearch: string) => {
    const query =
      textSearch === ''
        ? { surname: '100' }
        : {
          surname: textSearch,
        }
    const options = {
      limit: 5,
      skip: 0,
      orderBy: 'name',
    }
    dispatch(getMedecins(query, options))
  }

  return (
    <AddDoctorDialog
      {...props}
      doctors={doctorsData}
      isSearching={doctorListRequestTracker.loading}
      onItemsPerPageChange={handleItemsPerPageChange}
      onPageChange={handlePageChange}
      onSearchDoctor={handleSearchDoctor}
      totalDoctors={_.get(doctorSearchResult, 'totalCount', 0)}
    />
  )
}
